import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lmc-env/environment';
import { Observable } from 'rxjs';

export interface PromiseToPayConfigEmployee {
  employeeID: number;
  full_name: string;
  position: string;
}

/** Employee IDs granted each Promise to Pay permission. */
export interface PromiseToPayPermissionLists {
  changeOwner: number[];
  exceedCap: number[];
  backdate: number[];
  edit: number[];
}

export interface PromiseToPayConfig {
  permissions: PromiseToPayPermissionLists;
  employees: PromiseToPayConfigEmployee[];
}

@Injectable({
  providedIn: 'root',
})
export class PromiseToPayConfigService {
  private readonly uri: string = `${environment.DO_URL}/v2/config/promise-to-pay`;

  constructor(private readonly http: HttpClient) {}

  getConfig(): Observable<{ success: boolean; data: PromiseToPayConfig }> {
    return this.http.get<{ success: boolean; data: PromiseToPayConfig }>(this.uri);
  }

  updateConfig(permissions: PromiseToPayPermissionLists): Observable<{ success: boolean; message: string }> {
    return this.http.put<{ success: boolean; message: string }>(this.uri, { permissions });
  }
}
